import { RotateCcw, RotateCw } from 'lucide-react';

interface ImgRotateButtonsProps {
  onRotateForward: () => void;
  onRotateBackward: () => void;
}

export const ImgRotateButtons = ({
  onRotateBackward,
  onRotateForward,
}: ImgRotateButtonsProps) => {
  return (
    <>
      <button
        type="button"
        onClick={onRotateBackward}
        className="btn btn-light border-0 py-1 px-2"
        title="Rotar izquierda"
      >
        <RotateCcw size={18} />
      </button>
      <button
        type="button"
        onClick={onRotateForward}
        className="btn btn-light border-0 py-1 px-2"
        title="Rotar derecha"
      >
        <RotateCw size={18} />
      </button>
    </>
  );
};
